import { checkoutShippingOrderNotesEntryStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingOrderNotesEntry";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

checkoutShippingOrderNotesEntryStyles.textArea = {
    css: css`
            min-width: 100%;
            max-width: 100%;
            min-height: 50px;
            :focus {
                border: 2px solid ${getColor("common.border")} !important;
            }
        `,
}